import Vue from 'vue';
import datePicker from 'vue-bootstrap-datetimepicker';
Vue.use(datePicker);

window.$.extend(true, window.$.fn.datetimepicker.defaults, {
    icons: {
        time: 'far fa-clock',
        date: 'far fa-calendar',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        today: 'fas fa-calendar-check',
        clear: 'far fa-trash-alt',
        close: 'far fa-times-circle'
    }
});


// WEBPACK FOOTER //
// ./src/plugins/datatimepicker.js